<template>
    <footer class="tw-bg-slate-800 tw-py-8 tw-mt-16 tw-bottom-0">
      <div class="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <!-- Grid principal -->
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-8">

          <!-- Logo y descripción -->
          <div class="tw-col-span-1 md:tw-col-span-2 tw-text-center md:tw-text-left">
            <h2 class="tw-text-2xl tw-font-bold tw-text-gray-50">dtt.travel</h2>
            <p class="tw-mt-4 tw-text-gray-50 tw-text-sm">
              {{ $t("lang.Footer.text") }}
            </p>
          </div>

          <!-- Enlaces rápidos -->
          <div>
            <h3 class="tw-text-gray-50 tw-font-semibold tw-mb-4 tw-text-center md:tw-text-left">{{ $t("lang.Footer.links") }}</h3>
            <ul class="tw-space-y-2 tw-text-center md:tw-text-left">
              <li class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-text-gray-50 tw-text-sm">
                <router-link to="/" class="tw-text-gray-50 hover:tw-text-gray-200 tw-text-sm router">{{ $t("lang.Footer.home") }}</router-link>
              </li>
              <li class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-text-gray-50 tw-text-sm">
                <a href="https://www.dtt.travel/" target="_blank" class="tw-text-gray-50 hover:tw-text-gray-200 tw-text-sm">{{ $t("lang.Footer.about") }}</a>
              </li>
              <li class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-text-gray-50 tw-text-sm">
                <a href="https://www.dtt.travel/contacto/" target="_blank" class="tw-text-gray-50 hover:tw-text-gray-200 tw-text-sm">{{ $t("lang.Footer.contactUs") }}</a>
              </li>
            </ul>
          </div>

          <!-- Contacto -->
          <div>
            <h3 class="tw-text-gray-50 tw-font-semibold tw-mb-4 tw-text-center md:tw-text-left">{{ $t("lang.Footer.contact") }}</h3>
            <ul class="tw-space-y-2">
              <li class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-text-gray-50 tw-text-sm">
                <i class="fas fa-envelope tw-mr-2"></i>
                support@dtt.travel
              </li>
              <li class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-text-gray-50 tw-text-sm">
                <i class="fas fa-phone tw-mr-2"></i>
                +56 9 3927 0441
              </li>
              <li class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-text-gray-50 tw-text-sm">
                <i class="fas fa-map-marker-alt tw-mr-2"></i>
                Santiago, Chile
              </li>
            </ul>
          </div>
        </div>

        <!-- Línea divisoria -->
        <div class="tw-border-t tw-border-gray-50 tw-mt-8 tw-pt-8">
          <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center">
            <!-- Copyright -->
            <p class="tw-text-gray-50 tw-text-sm">
              © {{ new Date().getFullYear() }} dtt.travel. {{ $t("lang.Footer.copyright") }}
            </p>
          </div>
        </div>
      </div>
    </footer>
  </template>

  <script>
  export default {
    name: 'FooterComponent'
  }
  </script>

  <style scoped>
  .router{
      text-decoration: none !important;
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
      color: #f9fafb !important;
  }

  .router:active{
    text-decoration: none !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: #f9fafb !important;
  }

  .router:visited{
    color: #f9fafb !important;
  }

  .router:hover{
    color: #f9fafb !important;
    text-decoration: none !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  </style>


// WEBPACK FOOTER //
// src/components/FooterComponent.vue